"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFirstOptionFromGroup = exports.getFirstOption = void 0;
const getFirstOption = options => {
  // pick the first option from the options
  if (options.length > 0) {
    return options[0];
  }
  return null;
};
exports.getFirstOption = getFirstOption;
const getFirstOptionFromGroup = groupTitleOptions => {
  if (groupTitleOptions.length > 0) {
    const firstGroup = groupTitleOptions[0];
    if (firstGroup.options && firstGroup.options.length > 0) {
      return firstGroup.options[0];
    }
  }
  return null;
};
exports.getFirstOptionFromGroup = getFirstOptionFromGroup;